// extracted by mini-css-extract-plugin
export default {"background":"Home_background__OAJIj"};